var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95343 8L13.9534 1",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9534 1L9.3412 13.7723C9.31007 13.8403 9.26009 13.8978 9.1972 13.9382C9.1343 13.9785 9.06115 14 8.98642 14C8.91169 14 8.83853 13.9785 8.77564 13.9382C8.71274 13.8978 8.66276 13.8403 8.63163 13.7723L6.14812 8.80531L1.18111 6.3218C1.11318 6.29067 1.05561 6.24068 1.01525 6.17779C0.974885 6.1149 0.95343 6.04174 0.95343 5.96701C0.95343 5.89228 0.974885 5.81913 1.01525 5.75623C1.05561 5.69334 1.11318 5.64336 1.18111 5.61223L13.9534 1Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send-message.5b490591400b7119256379dff6185ae4.svg";
export { ForwardRef as ReactComponent };